export default __webpack_public_path__ + "static/type-inference-c24841ebb1858d53373521e86bf4f673.png";